'use strict';

module.exports = ['Corkage Allowed', 'Outside Dessert OK', 'Customized Menus', 'Onsite Parking (Paid)', 'Onsite Parking (Free)', 'Parking Garage Nearby', 'Beer & Wine Only', 'BYOB', 'WIFI', 'Validated Parking'];